import ControlViewModel from '@/ViewModels/ControlViewModel';
import * as DateHelper from '@/Utility/DateHelper'

export default class KendoDateAndOrTimePickerViewModelBase extends ControlViewModel {

    /**
     * Der DateTime-String vom .NET
     */
    public value: KnockoutObservable<string>;

    /**
     * Der vom Benutzer eingegebene Text
     * Die Subscriber m�ssen auch benachrichtig werden, wenn sich der Wert von rawValue zum selben Wert �ndert, damit die Validierung immer angesto�en wird.
     */
    public rawValue: KnockoutObservable<string>;

    /**
     * Ein Placeholder falls das Control keine Eingabe enth�lt
     */
    public placeholder: KnockoutComputed<string>;

    /**
     * Das Date-Objekt
     */
    public date: KnockoutComputed<Date>;

    private onResettedCallback: VoidFunction;

    public constructor(protected params: any) {
        super(params);
        this.value = this.observableOrDefault(params.value, '');
        this.rawValue = this.observableOrDefault(params.rawValue, '');
        this.date = this.definePureComputed({
            read: () => {
                const value = this.value();
                const date = DateHelper.parseDotNetDateTimeString(value);
                return date;
            },
            write: (date) => {
                const value = this.parseToDotNetString(date);
                this.value(value);
            }
        });
        this.placeholder = this.createPlaceHolder();
        this.onResettedCallback = () => { };
    }

    /**
     * Der Platzhalter f�r das Eingabefeld
     */
    protected createPlaceHolder(): KnockoutComputed<string> {
        return null;
    }

    /**
     * Wandelt den Wert in einen DotNetString um
     * @param date
     */
    protected parseToDotNetString(date: Date): string {
        return '';
    }

    public onResetted(callback: VoidFunction) {
        this.onResettedCallback = callback;
    }

    /**
     * @override 
     * @inheritdoc
     */
    public resetValue(): void {
        this.value(null);
        this.rawValue(null);
        this.value.notifySubscribers();
        this.rawValue.notifySubscribers();
        this.onResettedCallback();
    }
}